import React, { useState, useEffect } from 'react';
import UserService from '../services/userService';

const UserManagementPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [newUser, setNewUser] = useState({
    username: '',
    email: '',
    password: '',
    role: 'USER'
  });

  // Kullanıcıları getirme fonksiyonu - GERÇEK API
  const fetchUsers = async () => {
    try {
      setLoading(true);
      setError('');

      console.log('🔄 Fetching users from API...');
      const users = await UserService.getAllUsers();
      setUsers(users);

    } catch (err) {
      console.error('❌ Error fetching users:', err);
      setError(err.response?.data?.message || 'Kullanıcılar yüklenemedi');
    } finally {
      setLoading(false);
    }
  };

  // Yeni kullanıcı ekleme fonksiyonu
  const handleAddUser = async () => {
    try {
      setLoading(true);

      // Backend'e kullanıcıyı gönder
      await UserService.createUser(newUser);

      // Başarılı olursa
      setShowAddModal(false);
      setNewUser({ username: '', email: '', password: '', role: 'USER' });
      await fetchUsers(); // Listeyi yenile

      console.log('✅ Yeni kullanıcı başarıyla eklendi!');

    } catch (err) {
      console.error('❌ Kullanıcı eklenemedi:', err);
      setError('Kullanıcı eklenemedi: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (userId) => {
    try {
      setLoading(true);
      await UserService.toggleUserStatus(userId);
      await fetchUsers(); // Listeyi yenile
    } catch (err) {
      setError('Durum değiştirilemedi: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <div style={{ fontSize: '2rem' }}>⏳</div>
        <div>Kullanıcılar yükleniyor...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        padding: '2rem',
        backgroundColor: '#fef2f2',
        color: '#dc2626',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <h3>❌ Hata</h3>
        <p>{error}</p>
        <button
          onClick={fetchUsers}
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Tekrar Dene
        </button>
      </div>
    );
  }

  return (
    <div>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem'
      }}>
        <div>
          <h2 style={{
            margin: 0,
            color: '#1e293b',
            fontSize: '1.75rem',
            fontWeight: '700'
          }}>
            👥 Kullanıcı Yönetimi
          </h2>
          <p style={{
            margin: '0.25rem 0 0 0',
            color: '#64748b',
            fontSize: '0.95rem'
          }}>
            Sistem kullanıcılarını yönetin
          </p>
        </div>

        <button
          onClick={fetchUsers}
          style={{
            padding: '0.6rem 1.2rem',
            backgroundColor: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500'
          }}
        >
          🔄 Yenile
        </button>
      </div>

      {/* Kullanıcı Listesi Tablosu */}
      <div style={{
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
        border: '1px solid #e2e8f0'
      }}>
        {/* 🔥 BAŞLIK + YENİ KULLANICI BUTONU */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem'
        }}>
          <h3 style={{
            margin: 0,
            color: '#374151',
            fontSize: '1.1rem',
            fontWeight: '600'
          }}>
            Kullanıcı Listesi ({users.length} kullanıcı)
          </h3>

          {/* YENİ KULLANICI BUTONU */}
          <button
            onClick={() => setShowAddModal(true)}
            style={{
              padding: '0.6rem 1.2rem',
              backgroundColor: '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              fontWeight: '500',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <span>➕</span>
            Yeni Kullanıcı
          </button>
        </div>

        {users.length === 0 ? (
          <div style={{
            padding: '3rem',
            textAlign: 'center',
            color: '#6b7280'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>👤</div>
            <p>Henüz kullanıcı bulunmuyor</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: '0.9rem'
            }}>
              <thead>
                <tr style={{
                  backgroundColor: '#f8fafc',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <th style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Kullanıcı
                  </th>
                  <th style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Email
                  </th>
                  <th style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Rol
                  </th>
                  <th style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    Durum
                  </th>
                  <th style={{
                    padding: '1rem',
                    textAlign: 'left',
                    fontWeight: '600',
                    color: '#374151'
                  }}>
                    İşlemler
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, index) => (
                  <tr
                    key={user.id}
                    style={{
                      borderBottom: index < users.length - 1 ? '1px solid #e2e8f0' : 'none',
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc'
                    }}
                  >
                    <td style={{ padding: '1rem' }}>
                      <div style={{ fontWeight: '500', color: '#1f2937' }}>
                        {user.username}
                      </div>
                    </td>
                    <td style={{ padding: '1rem', color: '#6b7280' }}>
                      {user.email}
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <span style={{
                        padding: '0.25rem 0.75rem',
                        borderRadius: '20px',
                        fontSize: '0.8rem',
                        fontWeight: '500',
                        backgroundColor: user.role === 'ADMIN' ? '#fef3c7' : '#e0f2fe',
                        color: user.role === 'ADMIN' ? '#92400e' : '#075985'
                      }}>
                        {user.role === 'ADMIN' ? '👑 Admin' : '👤 User'}
                      </span>
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <span style={{
                        padding: '0.25rem 0.75rem',
                        borderRadius: '20px',
                        fontSize: '0.8rem',
                        fontWeight: '500',
                        backgroundColor: user.isActive ? '#d1fae5' : '#fef2f2',
                        color: user.isActive ? '#065f46' : '#dc2626'
                      }}>
                        {user.isActive ? '✅ Aktif' : '❌ Pasif'}
                      </span>
                    </td>
                    <td style={{ padding: '1rem' }}>
                      <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <button
                          style={{
                            padding: '0.4rem 0.8rem',
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '0.8rem'
                          }}
                        >
                          Düzenle
                        </button>
                        <button
                          onClick={() => handleToggleStatus(user.id)}
                          disabled={loading}
                          style={{
                            padding: '0.4rem 0.8rem',
                            backgroundColor: user.isActive ? '#ef4444' : '#10b981',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontSize: '0.8rem',
                            opacity: loading ? 0.6 : 1
                          }}
                        >
                          {loading ? '⏳' : user.isActive ? 'Pasif Et' : 'Aktif Et'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* YENİ KULLANICI MODAL */}
      {showAddModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '500px',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '1.5rem'
            }}>
              <h3 style={{ margin: 0, color: '#1f2937' }}>Yeni Kullanıcı Ekle</h3>
              <button
                onClick={() => setShowAddModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280'
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Kullanıcı Adı *
                </label>
                <input
                  type="text"
                  value={newUser.username}
                  onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
                  placeholder="kullanici_adi"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Email *
                </label>
                <input
                  type="email"
                  value={newUser.email}
                  onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                  placeholder="email@firma.com"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Şifre *
                </label>
                <input
                  type="password"
                  value={newUser.password}
                  onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                  placeholder="En az 6 karakter"
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.5rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  Rol
                </label>
                <select
                  value={newUser.role}
                  onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '1rem',
                    backgroundColor: 'white'
                  }}
                >
                  <option value="USER">👤 User</option>
                  <option value="ADMIN">👑 Admin</option>
                </select>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '1rem',
              marginTop: '2rem',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowAddModal(false)}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: '#f3f4f6',
                  color: '#374151',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.9rem',
                  fontWeight: '500'
                }}
              >
                İptal
              </button>
              <button
                onClick={handleAddUser}
                disabled={!newUser.username || !newUser.email || !newUser.password}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: (!newUser.username || !newUser.email || !newUser.password) ? '#9ca3af' : '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: (!newUser.username || !newUser.email || !newUser.password) ? 'not-allowed' : 'pointer',
                  fontSize: '0.9rem',
                  fontWeight: '500'
                }}
              >
                Kullanıcı Ekle
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default UserManagementPage;